import { round } from "lodash";
import {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
  useEffect,
  useMemo,
} from "react";

type LayoutContextType = {
  navbarHeightPx: number;
  setNavbarHeightPx: Dispatch<SetStateAction<number>>;
  navbarHeightRem: number;
};

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export function LayoutProvider({ children }: { children: ReactNode }) {
  const [navbarHeightPx, setNavbarHeightPx] = useState(0);
  const [navbarHeightRem, setNavbarHeightRem] = useState(0);

  useEffect(() => {
    const rootFontSize = parseFloat(
      window.getComputedStyle(document.documentElement).fontSize,
    );
    setNavbarHeightRem(round(navbarHeightPx / rootFontSize));
  }, [navbarHeightPx]);

  const value = useMemo(
    () => ({
      navbarHeightPx,
      setNavbarHeightPx,
      navbarHeightRem,
    }),
    [navbarHeightPx, navbarHeightRem],
  );

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
}

export function useLayout() {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error("useLayout must be used within a LayoutProvider");
  }
  return context;
}
